// extracted by mini-css-extract-plugin
export default {"base":"Dialog_base__XzKcg","isOpened":"Dialog_isOpened__Hb7uf","overlay":"Dialog_overlay__G54-R","dialog":"Dialog_dialog__dfT4Q","close":"Dialog_close__1w+A4"};